import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <Hero />

        <CategoryNav />

        <FeaturedArticles />

        <FAQ />
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '伦理剧精选',
            url: 'https://lunliju.example.com',
            description: '伦理剧是以家庭关系、情感纠葛与道德抉择为核心的影视类型。伦理剧精选汇聚最新最热伦理剧推荐、剧情解析与观看指南，帮助你找到最触动心灵的伦理剧作品。',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://lunliju.example.com/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}